<template>
  <section class="online-course-details">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="generic-wizard-heading">Select Your Course</div>
        </div>
      </div>

      <!-- <div class="tabouter" v-if="tagsFilters.length > 1">
        <div class="wizard3 mt-5" id="tag-filter">
          <div class="tabwrapper">
            <div class="tabItem" v-for="item in tagsFilters" :key="item.TagId">
              <label class="labelContainer" :class="selected.find((el) => el === item.TagId) === item.TagId ? 'selectedTag' : ''"
                >{{ item.TagName }}
                <input type="checkbox" :value="item.TagId" v-model="selected" @change="selectedValues" :disabled="sendingRequest" />
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>
      </div> -->
      <div class="tabs-slider" v-if="tagsFilters.length > 1">
        <div class="wizard3 mt-5 " id="tag-filter">
          <ssr-carousel :slides-per-page='null'>
            <div class="tabwrapper">
              <div class="tabItem" v-for="item in tagsFilters" :key="item.TagId">
                <label class="labelContainer"
                  :class="selected.find((el) => el === item.TagId) === item.TagId ? 'selectedTag' : ''">{{ item.TagName
                  }}
                  <input type="checkbox" :value="item.TagId" v-model="selected" @change="selectedValues"
                    :disabled="sendingRequest" />
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
          </ssr-carousel>
        </div>
      </div>

      <skeleton-loader id="examCoursesLoader" :count="3" :showEmptyTemplate="true" :defaultLoadingProp="true">
        <template v-slot:default="{ isLoading }">
          <div class="generic-layout-cntr" v-if="courseList.length !== 0">
            <template v-for="(course, index) in courseList">
              <div v-if="!course.IsFree" class="col-lg-4 col-md-6  mb-40 special" :key="index">
                <course-card :model="course" :programCategoryId="programCategoryId" />
              </div>
            </template>
          </div>
          <no-record-template v-else-if="isLoading && courseList.length == 0"></no-record-template>
          <div class="load-more">
            <a v-if="canCoursesLoadMore && isLoading" id="btnLoadMore" @click="loadMore" href="javascript:void(0)"
              class>
              <i class="far fa-chevron-down"></i>
              <div class="loadmore-separator"></div>
            </a>
          </div>
        </template>
      </skeleton-loader>
    </div>
    <cartConfirmationModal />
  </section>
</template>
<script>
import { appConstants } from "../../../common/constants";
import { mapGetters, mapActions } from "vuex";
import { classCourses as classCoursesStoreKeys, course as courseStoreKeys } from "../../../store/keys";
import courseTemplate from "../courseTemplate.vue";
import courseCard from "../../../components/courseCard.vue";
import breadcrumb from "../breadcrumb.vue";
import cartConfirmationModal from "../cartConfirmationModal.vue";
import SsrCarousel from "vue-ssr-carousel";
import ssrCarouselCss from "vue-ssr-carousel/index.css";
export default {
  components: {
    courseTemplate,
    breadcrumb,
    cartConfirmationModal,
    courseCard,
    SsrCarousel,
  },
  mounted() {
    //this.resetClassCourses();
    this.getClassCourses();
  },
  computed: {
    ...mapGetters(courseStoreKeys.namespace, courseStoreKeys.getters),
    ...mapGetters(classCoursesStoreKeys.namespace, classCoursesStoreKeys.getters),
  },
  data: function () {
    return {
      coursePaging: {
        pageNumber: 1,
        pageSize: 12,
      },
      showRecordsNotFound: false,
      programCategoryId: appConstants.enums.programCategory.Class,
      selected: [],
      timeoutId: null,
      sendingRequest: false,
    };
  },
  beforeDestroy() { },
  destroyed() {
    //this.resetClassCourses();
    this.reset_TagsFilter();
  },
  methods: {
    ...mapActions(courseStoreKeys.namespace, courseStoreKeys.actions),
    ...mapActions(classCoursesStoreKeys.namespace, classCoursesStoreKeys.actions),
    courseSubscriptionType() {
      let subscriptionType = this.$route.name === "FreeTrialClass" ? appConstants.enums.subscriptionType.Free : appConstants.enums.subscriptionType.All;
      return subscriptionType;
    },
    selectedValues(event) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      if (event.target.checked && event.target.value === "-1") {
        let selectAllFilters = this.tagsFilters.map((el) => ({ ...el, IsDefaultSelected: true }));
        this.selected = selectAllFilters.filter((el) => el.IsDefaultSelected).map((el) => el.TagId);
      } else if (!event.target.checked && event.target.value === "-1") {
        this.selected = [];
      } else if (!event.target.checked && event.target.value !== "-1") {
        let index = this.selected.indexOf(-1);
        if (index !== -1) this.selected.splice(this.selected.indexOf(-1), 1);
      }
      if (this.selected.length) {
        this.coursePaging.pageNumber = 1;
        this.timeoutId = setTimeout(() => {
          this.getClassCourses(null, this.selected);
        }, 1000);
      }
    },
    getClassCourses(pagingMode, selectedTags) {
      this.get_ClassCourses({
        data: {
          AcademicProgramId: this.selectedProgram.id,
          BoardId: this.selectedBoard.id,
          CourseGroupId: this.selectedCourseGroup.id,
          ProgramCategoryId: appConstants.enums.programCategory.Class,
          SubscriptionType: this.courseSubscriptionType(),
          PageNumber: this.coursePaging.pageNumber,
          PageSize: this.coursePaging.pageSize,
          ApplyDefaultTagFilter: true,
          ...(selectedTags && selectedTags.length && { TagIds: [...selectedTags] }),
        },
        config: {
          loader: {
            show: true,
            id: "examCoursesLoader",
          },
        },
        pagingMode: pagingMode,
      })
        .then((response) => {
          this.sendingRequest = false;
          this.showRecordsNotFound = true;
          this.coursePaging.pageNumber = response.PageNumber;
          this.selected = this.tagsFilters.filter((el) => el.IsDefaultSelected).map((el) => el.TagId);
        })
        .catch((ex) => {
          this.sendingRequest = false;
          // this.$alertError(ex.message);
          console.log(ex)
        });
    },
    resetClassCourses() {
      this.reset_ClassCourses().then((response) => {
        this.getClassCourses();
      });
    },
    updateSelectedSOS(course) {
      this.update_SelectedSOS({
        data: { id: course.SOSId, name: course.SOSName },
        config: {
          loader: {
            show: false,
          },
        },
      })
        .then((response) => {
          // this.$router.push(
          //   "/class/detail/9th-25/punjab/engineering?s=" +
          //     this.selectedCourseInfo.sos.id +
          //     "&b=" +
          //     this.selectedCourseInfo.board.id +
          //     "&g=" +
          //     this.selectedCourseInfo.courseGroup.id
          // );
        })
        .catch((ex) => {
          //this.$alertError(ex.message);
          console.log(ex)
        });
    },
    loadMore() {
      this.coursePaging.pageNumber++;
      this.getClassCourses(appConstants.enums.pagingMode.loadMore, this.selected);
    },
    UpdateNextWizard() {
      this.$router.push("/class/detail/" + this.RemoveSpecialChars(this.selectedCourseInfo.sos.name) + "/" + this.RemoveSpecialChars(this.selectedCourseInfo.board.name) + "/" + this.RemoveSpecialChars(this.selectedCourseInfo.courseGroup.name) + "?s=" + this.selectedCourseInfo.sos.id + "&b=" + this.selectedCourseInfo.board.id + "&g=" + this.selectedCourseInfo.courseGroup.id).catch(() => { });
    },
  },
};
</script>
<style scoped>
.loadmore-separator {
  background: #ccc;
  height: 1px;
  width: 70%;
  margin-top: -17px;
  margin: -17px auto 0 auto;
}

.load-more {
  text-align: center;
  cursor: pointer;
}

.load-more i {
  background: #fff;
  padding: 9px 10px;
  border-radius: 50%;
  font-size: 17px;
  box-shadow: 0 0 10px 0px #d8d8d8;
}

.layour-padding {
  padding-top: 25px !important;
}

.labelContainer {
  display: inline-block;
  position: relative;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 18px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border-radius: 20px;
  padding: 5px 15px 5px 35px;
  background-color: #fff;
  margin: 0px 5px;
}

/* Hide the browser's default checkbox */

.labelContainer input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */

.checkmark {
  position: absolute;
  left: -2px;
  height: 25px;
  width: 25px;
  margin: 1px 7px;
  background-color: #fff;
  border-radius: 50%;
  border: 1px solid #ddd;
}

/* On mouse-over, add a grey background color */

.labelContainer:hover input~.checkmark {
  background-color: #fff;
}

/* When the checkbox is checked, add a blue background */

.labelContainer input:checked~.checkmark {
  background-color: #30eaae;
}

/* Create the checkmark/indicator (hidden when not checked) */

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */

.labelContainer input:checked~.checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */

.labelContainer .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>
